export default "__VITE_ASSET__2d35b895__"